var _excluded = ["children", "className", "status"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
require("./field-hint.css");
var styles = {
  "hint": "hint-2WyRj",
  "hintSuccess": "hintSuccess-3MR_9",
  "hintWarning": "hintWarning-3JYx2",
  "hintError": "hintError-3CNVs"
};
var FieldHint = _ref => {
  var {
      children,
      className,
      status
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (!children) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cs(styles.hint, className, {
      [styles.hintSuccess]: status === 'success',
      [styles.hintWarning]: status === 'warning',
      [styles.hintError]: status === 'error'
    })
  }, otherProps), children);
};
FieldHint.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  status: PropTypes.oneOf(['success', 'warning', 'error'])
};
FieldHint.defaultProps = {
  children: null,
  className: null,
  status: null
};
export default FieldHint;